import React, { createContext, useContext, useState } from "react";
interface AuthContextType {
  email: string;
  setEmail: (email: string) => void;
  buttons: React.ReactNode[];
  setButtons: (buttons: React.ReactNode[]) => void;
  searchValue: string;
  setSearchValue: (value: string) => void;
}

const AuthContext = createContext<AuthContextType>({
  email: "",
  setEmail: () => {},
  buttons: [],
  setButtons: () => {},
  searchValue: "",
  setSearchValue: () => {},
});
export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [email, setEmail] = useState<string>("");
  const [buttons, setButtons] = useState<React.ReactNode[]>([]);
  const [searchValue, setSearchValue] = useState("");

  const value: AuthContextType = {
    email,
    setEmail,
    buttons,
    setButtons,
    searchValue,
    setSearchValue,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
